<ion-card>
    <ion-card-content>
        <ion-label>
            <h2>{{equipment.description}} - {{equipment.pdesc}} - {{equipment.reg}}</h2>
        </ion-label>
    </ion-card-content>
    <ion-card-content>
        <ion-item lines="none">
            <ion-label [color]="document.site.id !== equipment.site ? 'danger': 'dark'">
                <p>Current Status: {{status}}</p>
                <p *ngIf="document.site.id !== equipment.site">ITEM REGISTERED IN WRONG WARD!</p>
                <p *ngIf="document.site.id === equipment.site && equipment.stat === 200">ITEM IN BUFFER STOCK</p>
            </ion-label>
        </ion-item>
        <ion-segment color="primary">
            <ion-segment-button *ngIf="document.site.id !== equipment.site" (click)="createTransfer()">
                Transfer Ward
            </ion-segment-button>
            <ion-segment-button *ngIf="equipment.stat !== 2" (click)="createContract()">
                Create Contract
            </ion-segment-button>
            <ion-segment-button (tap)="modalController.dismiss()">OK</ion-segment-button>
        </ion-segment>
    </ion-card-content>
</ion-card>
